import { FC } from "react";
import { AthleticFormSubmissionFileDto } from "../../../../models/api-models/guardians/guardian-form-submission";
import React from "react";
import { MediaApi } from "../../../../api/MediaApi";

interface FileLinkProps {
    files?: AthleticFormSubmissionFileDto[],
    value: string
}

export const FileLink: FC<FileLinkProps> = ({ value, files = [] }) => {

    const url = MediaApi.download(value);
    const file = files.find(f => f.mediaId === value);

    return <a className="field-name-value field-name-value-link" href={url}>{file && file.title ? file.title : 'test' }</a>
}